import React from 'react';
import ClientFileReplication from './ClientFileReplication';
import PrimaryClusterable from './PrimaryClusterable';
import ReadOnlyClusterable from './ReadOnlyClusterable';
import ErrorContent from './ErrorContent';

const ClusterVerbiageContent = ({ potentialRole, uniqId }) => {
	switch (potentialRole) {
		case 'client':
			return <ClientFileReplication />;
		case 'primary':
			return <PrimaryClusterable uniqId={uniqId} />;
		case 'read-only':
			return <ReadOnlyClusterable />;
		default:
			return <ErrorContent />;
	}
};

export default ClusterVerbiageContent;
